import { render } from "./AccessibilityView.vue?vue&type=template&id=03e80368&scoped=true"
import script from "./AccessibilityView.vue?vue&type=script&lang=js"
export * from "./AccessibilityView.vue?vue&type=script&lang=js"

import "./AccessibilityView.vue?vue&type=style&index=0&id=03e80368&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03e80368"]])

export default __exports__